module.exports = __webpack_public_path__ + "static/ogimg-media-698740da7cb74b638fb1b70011a2d52b.jpg";